export const DOWNLOAD_SOUND_ID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export type DownloadAccountTarget =
  | { kind: 'sound'; soundId: string }
  | { kind: 'unattributed' }

export function downloadAccountTarget(
  soundId: string | null | undefined,
): DownloadAccountTarget {
  const trimmed = typeof soundId === 'string' ? soundId.trim() : ''
  if (DOWNLOAD_SOUND_ID_RE.test(trimmed)) {
    return { kind: 'sound', soundId: trimmed }
  }
  return { kind: 'unattributed' }
}

export function downloadAccountPath(target: DownloadAccountTarget): string {
  switch (target.kind) {
    case 'sound':
      return `/api/sounds/${target.soundId}/download`
    case 'unattributed':
      return '/api/downloads'
    default: {
      const _exhaustive: never = target
      return _exhaustive
    }
  }
}

/** Count against the library row only when that row actually loaded, not merely when `?sound=` is present. */
export function libraryExportSoundId(input: {
  soundId: string | undefined
  librarySoundLoaded: boolean
}): string | undefined {
  if (!input.librarySoundLoaded) return undefined
  return input.soundId
}
